import { AuthPage } from "@refinedev/core";

export const ForgotPassword = () => {
  return <AuthPage type="forgotPassword" />;
};
